import { gql } from '@apollo/client';

const CategorySuggestQuery = gql`
  query CategorySuggestQuery($query: String!, $first: Int!) {
    categorySuggest(query: $query, first: $first) {
      edges {
        node {
          id
          name
          path
        }
      }
    }
  }
`;

export default CategorySuggestQuery;
